import Phaser from 'phaser';

export default class TilesetManager {
  private scene: Phaser.Scene;
  private tilesets: Map<string, Phaser.Tilemaps.Tileset | null>;
  
  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.tilesets = new Map();
  }
  
  // Initialize tilesets for a given map and level
  public loadTilesets(map: Phaser.Tilemaps.Tilemap, level?: string): Array<Phaser.Tilemaps.Tileset> {
    // Define all tileset mappings
    const allTilesetMappings = [
      { mapKey: 'build_atlas', textureKey: 'tiles1' },
      { mapKey: 'Building', textureKey: 'tiles2' },
      { mapKey: 'Cars_final', textureKey: 'tiles3' },
      { mapKey: 'city_outside', textureKey: 'tiles4' },
      { mapKey: 'inside', textureKey: 'tiles5' },
      { mapKey: 'Interior-Furniture', textureKey: 'tiles6' },
      { mapKey: 'Interior-Walls-Beige', textureKey: 'tiles7' },
      { mapKey: 'Laserfence', textureKey: 'tiles8' },
      { mapKey: 'Objects', textureKey: 'tiles9' },
      { mapKey: 'Street', textureKey: 'tiles10' },
      { mapKey: 'terrain_atlas', textureKey: 'tiles11' },
      { mapKey: 'tileset_town_multi_v002', textureKey: 'tiles12' },
      { mapKey: 'treetop', textureKey: 'tiles13' },
      { mapKey: 'woodland_indoor', textureKey: 'tiles14' },
      { mapKey: 'Room1Tile', textureKey: 'tiles15' },
      { mapKey: 'pinturas-atlas', textureKey: 'tiles16' }
    ];
    
    // Clear existing tilesets
    this.tilesets.clear();
    
    if (level === 'level6' || level === 'level7') {
      // For level6, load ALLtilesets including 15 and 16
      allTilesetMappings.forEach(({ mapKey, textureKey }) => {
        const tileset = map.addTilesetImage(mapKey, textureKey);
        this.tilesets.set(mapKey, tileset);
      });
    } else {
      // For other levels, load all tilesets EXCEPT 15 and 16
      const standardTilesets = allTilesetMappings.filter(mapping => 
        mapping.textureKey !== 'tiles15' && mapping.textureKey !== 'tiles16'
      );
      
      standardTilesets.forEach(({ mapKey, textureKey }) => {
        const tileset = map.addTilesetImage(mapKey, textureKey);
        this.tilesets.set(mapKey, tileset);
      });
    }
    
    // Return array of valid tilesets (non-null)
    return this.getAllTilesets();
  }
  
  // Get a specific tileset by its map key
  public getTileset(name: string): Phaser.Tilemaps.Tileset | null {
    return this.tilesets.get(name) || null;
  }
  
  // Get all tilesets as an array (filtering out null values)
  public getAllTilesets(): Array<Phaser.Tilemaps.Tileset> {
    const result: Array<Phaser.Tilemaps.Tileset> = [];
    this.tilesets.forEach(tileset => {
      if (tileset) result.push(tileset);
    });
    return result;
  }
}